import { prettify, renderEUDate } from "../../utils/utils";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

const columns = [
  {
    size: 120,
    enableColumnFilter: false,
    accessorKey: "description",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Descrizione",
  },
  {
    size: 120,
    enableColumnFilter: false,
    accessorKey: "serial_number",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Numero Seriale",
  },
  {
    size: 100,
    enableColumnFilter: false,
    accessorFn: (row) => renderEUDate(row.last_connection),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Ultima connessione",
  },
  {
    size: 5,
    accessorKey: "is_installed",
    enableColumnFilter: false, // TODO
    accessorFn: (row) => (row.is_installed ? "true" : "false"),
    filterVariant: "checkbox",
    Cell: ({ cell }) =>
      cell.getValue() === "true" ? (
        <DoneIcon color="success" />
      ) : (
        <CloseIcon color="error" />
      ),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Installato",
  },
  {
    size: 5,
    accessorKey: "is_online",
    enableColumnFilter: false, // TODO
    accessorFn: (row) => (row.is_online ? "true" : "false"),
    filterVariant: "checkbox",
    Cell: ({ cell }) =>
      cell.getValue() === "true" ? (
        <DoneIcon color="success" />
      ) : (
        <CloseIcon color="error" />
      ),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Online",
  },
];

export default columns;
